import { render, staticRenderFns } from "./PublishedBill.vue?vue&type=template&id=0799fb11&scoped=true&"
import script from "./PublishedBill.vue?vue&type=script&lang=js&"
export * from "./PublishedBill.vue?vue&type=script&lang=js&"
import style0 from "./PublishedBill.vue?vue&type=style&index=0&id=0799fb11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799fb11",
  null
  
)

export default component.exports